<template>
  <div class="liberar-pedidos-bloqueados">
    <nav-menu data-nav-menu="componente-menu"></nav-menu>  
    <div class="w3-main w3-animate-left w3-container">
      
      <header  class=" w3-col w3-padding-small">
        <h5 class="w3-left  w3-col"><b><i class="fa fa-check"></i> Liberar Pedidos Bloqueados</b></h5>
      </header>

      <span data-span="selecionar-empresas" class="w3-col texto-vermelho w3-left">
        <i class="fas fa-building"></i>
        <a  v-on:click="definirEmpresas(false)" href="#">Selecionar Empresas</a>
      </span>
      
      <div 
        style="font-size: 14px;"
        class="w3-conteiner">
        <span>{{getEmpresasSelecionadas}}</span>
      </div>

      <button 
        id="floating-button"
        title="Recarregar pedidos bloqueados"  
        class="w3-button w3-theme w3-circle w3-display-bottomright"
        v-on:click="recarregarInformacoes(false)">
        <i class="fa fa-sync-alt"/>
      </button>
      
      <pedidos-bloqueados 
        data-pedidos-bloqueados="componente-pedidos-bloqueados" 
        ref="pedidos_bloqueados">
      </pedidos-bloqueados>

      <!-- Inicio modal selecionar empresa -->
      <div 
        id="modalInserirEmpresas" 
        style="display: block" 
        v-if="mostrarModalInserirEmpresas" 
        class="w3-modal w3-card card-item">
        
        <div class="w3-modal-content w3-card w3-animate-zoom card-item" @click.stop>
          
          <div data-div="empresas-disponiveis" class="w3-container card-item">
            <span @click="mostrarModalInserirEmpresas = false" class="w3-button w3-display-topright">&times;</span>
            <h2 class="texto-vermelho titulo">Empresas Disponíveis</h2>
          </div>
          
          <thead
            data-thead="empresa-selecionando"
            class="w3-col w3-padding"
            style="margin-top: 6px;"
            :key="'empresa-selecionada' + empresa.empresa_id"
            v-for="empresa in empresas_autorizadas" 
            :class="getClasseEmpresaDisponivel(empresa.adicionado)" 
            v-on:click="adicionarRemoverEmpresa(empresa.empresa_id)">
            
            <strong class="w3-col">
              <i v-if="empresa.adicionado" class="far fa-check-square"></i>
              <i v-if="!empresa.adicionado" class="far fa-square"></i>
              &nbsp;&nbsp;
              {{empresa.empresa_id}} - {{empresa.nome_fantasia}}
              <a class="w3-hide-small">  -  {{empresa.cnpj}}</a>
            </strong>
          </thead>
          
          <footer class="w3-container conteudo-centralizado">
            <button 
              data-buttom="ok"
              class="w3-btn w3-theme" 
              id="btn-confirmar-acao" 
              style="margin-top: 10px; margin-bottom:10px"  
              v-on:click="mostrarModalInserirEmpresas = false">
              <span @click="recarregarInformacoes(true)">Ok</span>
            </button>
          </footer>

        </div>
      </div> 
    </div>

  </div>
</template>

<script>
  import store from '@/ambiente/store';
  import RSessao from '@/components/Rest/RSessao'
  import NavMenu from '@/components/Menu'
  import PedidosBloqueados from '@/components/PedidosBloqueados'
  import toastr from 'toastr'

  export default {
    name: 'LiberarPedidosBloqueados',
    components: {
      PedidosBloqueados,
      NavMenu
    },
    data() {
      return {
        api: process.env.API,
        empresas_autorizadas: [],
        empresa_mostrando_pedidos_bloqueados: '',
        processando: false,
        mostrarModalInserirEmpresas: false,
        
        /* Constantes */
        c_local_storage_empresa_pedido: 'liberacao-pedidos-empresas-autorizadas'
      }
    },
    computed: {
      getEmpresasSelecionadas() {
        let contador_empresas_selecionadas = 0;
        let retorno = '';
        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
          if (this.empresas_autorizadas[i].adicionado) {
            if (retorno != '') {
              retorno += ' / ';
            } 
            retorno += this.empresas_autorizadas[i].empresa_id + ' - ' + this.empresas_autorizadas[i].nome_fantasia;
            contador_empresas_selecionadas++;
          }
        }

        if (retorno == '') {
          return 'Nenhuma empresa foi selecionada.';
        }
        else if(contador_empresas_selecionadas == this.empresas_autorizadas.length){
          return 'Todas empresas foram selecionadas.';
        }

        else {
          return retorno;
        }
      }
    },
  
    methods: {
      async recarregarInformacoes(definir_local_storage){
        let empresas_ids = []        
        let empresas_gravar = []
        
        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
          if (this.empresas_autorizadas[i].adicionado) {
            empresas_ids.push(this.empresas_autorizadas[i].empresa_id)
          }

          await (empresas_gravar.push(
            {
              empresa_id: this.empresas_autorizadas[i].empresa_id,
              adicionado: this.empresas_autorizadas[i].adicionado,
              nome_fantasia: this.empresas_autorizadas[i].nome_fantasia
            }
          ))
        }

        if (definir_local_storage) {
          await(localStorage.setItem(this.c_local_storage_empresa_pedido, JSON.stringify(empresas_gravar)))
        }

        await(this.$refs.pedidos_bloqueados.definirEmpresasIds(empresas_ids));        
      },

      getEmpresasSelecionadasIds() {
        let retorno = [];
        if ((!this.empresas_autorizadas) || (this.empresas_autorizadas.length == 0)) {
          return retorno;
        }

        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
          if (this.empresas_autorizadas[i].adicionado) {
            (retorno.push(this.empresas_autorizadas[i].empresa_id));
          }
        }
      },
    
      async buscarEmpresasAutorizadas(){
        try {
          if (!RSessao.carregouSessao()) {
            await RSessao.buscarDadosCarregarSessao(this.axios);
        
          }
          this.empresas_autorizadas = await JSON.parse(JSON.stringify(store.state.empresas_autorizadas));
          
          if (this.empresas_autorizadas && this.empresas_autorizadas.length > 0) {
            for (let i = 0; i < this.empresas_autorizadas.length; i++) {
              this.empresas_autorizadas[i].adicionado = true;
            }
          }
  
          this.definirEmpresas(true);
        } catch (error) {
          toastr.error('Erro ao buscar empresas autorizadas!');
        }
      
      },
      
      async definirEmpresas(buscar_local_storage){
        if ((!buscar_local_storage) || (!localStorage.getItem(this.c_local_storage_empresa_pedido))) {
          this.mostrarModalInserirEmpresas = true;
          return;
        }

        let tem_empresa_selecionada = false;
        let empresas_selecionadas = JSON.parse(localStorage.getItem(this.c_local_storage_empresa_pedido));

        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
          for (let j = 0; j < empresas_selecionadas.length; j++) {
            if (this.empresas_autorizadas[i].empresa_id == empresas_selecionadas[j].empresa_id) {
              if (empresas_selecionadas[j].adicionado) {
                tem_empresa_selecionada = true;
              }
              this.empresas_autorizadas[i].adicionado = empresas_selecionadas[j].adicionado;
              break;
            }
          }
        }

        if (tem_empresa_selecionada) {
          await (this.recarregarInformacoes());
        }
      },
      
      async adicionarRemoverEmpresa(empresa_id){
        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
        
          if (this.empresas_autorizadas[i].empresa_id != empresa_id) {
            continue;
          }
          
          await (this.empresas_autorizadas[i].adicionado = !this.empresas_autorizadas[i].adicionado);
          break;
        }

        await (this.empresas_autorizadas = JSON.parse(JSON.stringify(this.empresas_autorizadas)));
      },

      getClasseEmpresaDisponivel: function(adicionado){
        if (adicionado) {
          return 'w3-theme label-clicavel';
        } else {
          return 'label-clicavel';
        }
      },
    },

    mounted() {
      this.processando = true;
      this.buscarEmpresasAutorizadas();
    }
  }
</script>

<style scoped>
  .row-pedidos-bloqueados {
    padding: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd; 
  }
  
  ::-webkit-scrollbar-thumb {
    background: #8d1007; 
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c; 
  }
  @media screen and (max-width: 767px){
    .w3-padding-large{
      padding: 12px 0 !important;
    }
    #pedidos-bloqueados {
      padding:0 !important;
      margin: 0 -8px
    }
  }
  #modalEmpresas{
    box-shadow: white 1px 3px 5px 3px ;
    background-color: white;
  }
  

  .card-item-empresa{
    background: #ddd;
    border-radius: 10px;
    box-shadow: white 3px 1px 2px 4px ;
  }
  
  
  .lista-empresas{
    background: white !important;
  }
  
  .empresas{
    display: inline-block;
  }

  #floating-button {
    z-index: 5 !important;
    padding-left: 14px!important; 
    padding-top: 7px!important; 
    font-size: 19px; 
    border-radius: 30px; 
    width:55px; 
    height:55px; 
    border: 4px solid #f7f7f7!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  #floating-button:hover {
    color: #9c1d1c!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/LiberarPedidosBloqueados.vue